const domain = window.location.origin
// const domainDev = 'http://mtwp.test'; //window.location.origin

const appConfig = {
  domain: domain,
  page: 'dashboard',
  api_base: 'https://mytips.milton-soft.com/api/',
  // api_base: domain + ':3000/api/',
  site_key: '6Ld3wZIdAAAAAKpicbWtijuHe0x9A_RGtpUaM099',
  ajax_url: domain +'/wp-admin/admin-ajax.php',
  uploads_path: domain +'/wp-content/uploads/users/',
  userExpired: new CustomEvent('user-expired'),
  userLogged: new CustomEvent('user-logged'),
  showMessage: detail => new CustomEvent('display-message', { detail })
}

export default appConfig
